import React from "react";
import { DialogContent as Content } from "material-ui-next/Dialog";
import { TextField, SelectField, CheckBox } from "components/support";

const DialogContent = props => {
  let mapPaymentType = props.paymentData.map(item => {
    return { value: item.uuid, label: item.label };
  });
  mapPaymentType = [{ value: "", label: "Selecionar" }, ...mapPaymentType];

  return (
    <Content>
      <SelectField
        floatingLabelText="Origem"
        value={props.form.origin}
        onChange={e => props.changeForm("origin", e.target.value)}
        fullWidth
        options={[
          { value: "", label: "Selecionar" },
          { value: "IFOOD", label: "IFOOD" }
        ]}
        errorText={props.error["origin"]}
      />

      <SelectField
        floatingLabelText="Metodo de pagamento"
        tooltip="Meio de pagamento para registro no caixa."
        value={props.form.paymentType}
        onChange={e =>
          props.changeForm("paymentType", e.target.value)
        }
        fullWidth
        options={mapPaymentType}
        errorText={props.error["paymentType"]}
      />

      <TextField
        fullWidth
        label="Nome"
        value={props.form.name}
        errorText={props.error["name"]}
        onChange={e => props.changeForm("name", e.target.value)}
      />

      <TextField
        fullWidth
        label="Login"
        errorText={props.error["login"]}
        value={props.form.login}
        onChange={e => props.changeForm("login", e.target.value)}
      />

      <TextField
        type="password"
        fullWidth
        label="Senha"
        errorText={props.error["password"]}
        value={props.form.password}
        onChange={e => props.changeForm("password", e.target.value)}
      />

      <CheckBox
        checked={props.form.auto_accept}
        style={checkBoxStyle}
        label="Aceitar pedidos automaticamente"
        onCheck={() =>props.changeForm("auto_accept", !props.form.auto_accept)}
      />
    </Content>
  );
};

const checkBoxStyle = {
  paddingLeft: 4
};

export default DialogContent;



// WEBPACK FOOTER //
// ./src/components/app/registration/company/form/integrations/order_integrations/DialogContent/index.jsx